import React, { useCallback, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { getFileNameWithoutExtension } from '../util';
import C from '../colors';

const CopyNames = inject('snackbarStore')(observer(({ snackbarStore, pictures }) => {
  const [showFallback, setShowFallback] = useState(false);
  const names = (pictures || []).map(p => getFileNameWithoutExtension(p.originalFileName || p.fileName)).join(',');
  const pictureCount = pictures?.length || 0;

  const handleCopy = useCallback(() => {
    if (!names) {
      snackbarStore.showSnackbar('当前没有已选照片', 'warning');
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(names).then(() => {
        snackbarStore.showSnackbar(`已复制 ${pictureCount} 个文件名`);
      }).catch(() => {
        setShowFallback(true);
        snackbarStore.showSnackbar('复制文本失败', 'error');
      });
    } else {
      setShowFallback(true);
    }
  }, [names, pictureCount, snackbarStore]);

  if (!pictures) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
      <button
        type="button"
        data-testid="copy-selected-file-names"
        disabled={!pictureCount}
        onClick={handleCopy}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 7,
          padding: '9px 14px', borderRadius: 9,
          border: 'none',
          background: pictureCount ? C.ink : C.hair2,
          color: pictureCount ? '#fff' : C.ink3,
          fontFamily: C.sans, fontSize: 13, fontWeight: 600,
          cursor: pictureCount ? 'pointer' : 'not-allowed',
          boxShadow: pictureCount ? '0 7px 16px -10px rgba(26,22,20,.8)' : 'none',
          whiteSpace: 'nowrap',
      }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="8" y="8" width="11" height="11" rx="2"/>
          <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>
        </svg>
        复制文件名
      </button>
      <a href="https://www.picsect.com/wiki/orders/lightroom_filter/" target="_blank" rel="noreferrer"
        aria-label="查看复制文件名使用帮助"
        style={{
          width: 28, height: 28, borderRadius: 14,
          display: 'grid', placeItems: 'center',
          fontFamily: C.serif, fontSize: 16, color: C.ink2,
          textDecoration: 'none', background: '#fff',
          border: `1px solid ${C.hair2}`,
        }}
        title="了解如何在 Lightroom 中筛选选定的照片"
      >?</a>
      {showFallback && (
        <textarea readOnly defaultValue={names} rows={3}
          style={{ fontSize: 11, fontFamily: 'monospace', padding: 4, border: `1px solid ${C.hair}`, borderRadius: 4, resize: 'none', width: 200 }}
        />
      )}
    </div>
  );
}));
export default CopyNames;
